import React from 'react';
import { motion } from 'framer-motion';
import { usePortal } from '../contexts/PortalContext';
import { ClientShell } from '../components/ClientShell';
import { Home } from './client/Home';
import { Project } from './client/Project';
import { Episodes } from './client/Episodes';
import { EpisodeReview } from './client/EpisodeReview';
import { Transcript } from './client/Transcript';
import { Files } from './client/Files';
import { Schedule } from './client/Schedule';
export function ClientApp() {
  const {
    clientRoute
  } = usePortal();
  return <ClientShell data-id="element-712" data-mp="k135md6smu2s">
      <motion.div key={clientRoute} initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-713" data-mp="k2npn8vheume">
        {clientRoute === 'home' && <Home data-id="element-714" data-mp="17pm646jlq2kb" />}
        {clientRoute === 'project' && <Project data-id="element-715" data-mp="17rgnxbzktek6" />}
        {clientRoute === 'episodes' && <Episodes data-id="element-716" data-mp="12zfdlvlyxxws" />}
        {clientRoute === 'episode' && <EpisodeReview data-id="element-717" data-mp="12xulsdr1gt2m" />}
        {clientRoute === 'transcript' && <Transcript data-id="element-718" data-mp="2q6jofoo1te9i" />}
        {clientRoute === 'files' && <Files data-id="element-719" data-mp="2q8wg4tjlz2zr" />}
        {clientRoute === 'schedule' && <Schedule data-id="element-720" data-mp="2u8n1uiua2sxf" />}
      </motion.div>
    </ClientShell>;
}